import { Component, OnInit } from '@angular/core';
import { InactiveTimerService } from '../../services/inactive-timer.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-inactive-timer',
  templateUrl: './inactive-timer.component.html',
  styleUrls: ['./inactive-timer.component.css']
})
export class InactiveTimerComponent implements OnInit {

  constructor(
    private inactiveTimerService: InactiveTimerService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  get secondsDisplay(): number {
    return this.inactiveTimerService.secondsDisplay;
  }

  get minutesDisplay(): number {
    return this.inactiveTimerService.minutesDisplay;
  }

  get timerIsStarted(): boolean {
    return this.inactiveTimerService.timerIsStarted;
  }

}
